function Backendcontroller () {
    const AZRFUNC_DOMAIN = (window.location.hostname.includes("dev") || window.location.hostname.includes("localhost")) ? "bsnr-dev.azurewebsites.net": "bsnr-prod.azurewebsites.net"

    return AZRFUNC_DOMAIN
}

export default Backendcontroller;